import jQuery from "jquery";
import { tns } from "tiny-slider/src/tiny-slider.js";
window.$ = window.jQuery = jQuery;

let cards = $(".cards-carousel");
if (cards.length > 0) {
    let slider = tns({
        container: ".cards-carousel",
        items: 1.3,
        gutter: 20,
        slideBy: 1,
        controls: false,
        nav: false,
        loop: true,
        mouseDrag: true,
        autoplay: false,
        startIndex: 0,
        rewind: true,
        center: false,
        fixedWidth: false,
    });
}
